<template>
  <div class="sp_meeting_modal_backdrop" @click.self="$emit('close')">
    <div class="sp_meeting_modal">
      <div class="sp_meeting_modal_header">
        <div class="sp_meeting_modal_title_row">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sp_meeting_modal_icon">
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h18" />
          </svg>
          <span class="sp_meeting_modal_title">{{ title }}</span>
        </div>
        <button class="sp_meeting_modal_close" @click="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6L6 18" /><path d="M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="sp_meeting_modal_body">
        <MeetingWidgetLink :link="url" @onSuccess="handleSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
import MeetingWidgetLink from "./link.vue";

export default {
  name: "MeetingWidgetModal",
  components: { MeetingWidgetLink },
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    onSuccess: {
      type: Function,
      required: false,
    },
  },
  methods: {
    handleSuccess(data) {
      this.$emit("onSuccess", data);
      this.$emit("close");
    },
  },
};
</script>

<style>
.sp_meeting_modal_backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.sp_meeting_modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 56rem;
  max-height: 90vh;
  margin: 0 1rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sp_meeting_modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.sp_meeting_modal_title_row {
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.sp_meeting_modal_icon {
  color: #2563eb;
  flex-shrink: 0;
}

.sp_meeting_modal_title {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.sp_meeting_modal_close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 0;
  flex-shrink: 0;
}

.sp_meeting_modal_close:hover {
  background: #f3f4f6;
  color: #111827;
}

.sp_meeting_modal_body {
  min-height: 0;
  height: 800px;
}
</style>
